// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__pnLm-","gfeWrapper":"CalendarEvent_gfeWrapper__NuiQW"};